var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative",attrs:{"role":"alert"}},[_c('strong',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.headline))]),_vm._v(" "),_c('span',{staticClass:"block sm:inline"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }